module.exports = __webpack_public_path__ + "static/retmes-ai-emtpy-canvas-hiw-d169c03762bf2a4bb4b6f352b28fd1d7.svg";